exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip.variation-tooltip .tooltip-inner{background:rgba(0,0,0,.9)}.tooltip.variation-tooltip .tooltip-arrow{border-color:rgba(0,0,0,.9)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be595e10","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/climan/components/directionIndicator.vue
// module id = 1391
// module chunks = 2